import { fetchApi } from '@/config/axiosSetting.ts';
import { SendToBranchActionMutationDataType } from '@/modules/FileDetail/queries/sendActions/sendToBranchAction/sendToBranchActionMutationFn.types';

export const sendToBranchActionMutationFn = (
  data: SendToBranchActionMutationDataType,
  id: string,
) => fetchApi.post(`actions/${id}/send_to_branch/`, data);
